import { ReactNode } from "react";

import { SxProps } from "@mui/material";
import { Dayjs } from "dayjs";

import { QuestVisibility } from "@pages/jobs-management/constants";

export type FieldSchemas = {
  [x: string]: InputComponentProps & {
    gridCol?: any;
    key: string;
  };
};

export type InputComponentProps = {
  label?: string;
  placeholder?: string;
  required?: boolean;
  step?: number;
  component?: (typeof INPUT_COMPONENT_TYPE)[keyof typeof INPUT_COMPONENT_TYPE];
  componentProps?: any;
  options?: { value: string; text: string }[];
  name?: string;
  sx?: SxProps;
  icon?: ReactNode;
  overview?: ReactNode;
  helperText?: ReactNode;
};

export const INPUT_COMPONENT_TYPE = {
  AVATAR_UPLOAD: "avatarUpload",
  INPUT_TEXT: "inputText",
  INPUT_NUMBER: "inputNumber",
  AUTOCOMPLETE: "autoComplete",
  RADIO: "radio",
  AREA: "area",
  DATE_PICKER: "datePicker",
  PROJECT: "project",
  FILE_UPLOAD: "fileUpload",
  CHECKBOX: "checkbox",
} as const;

type QuestVisibilityType = (typeof QuestVisibility)[keyof typeof QuestVisibility];

export enum PlatformEnum {
  LANCE_BOARD = "Lanceboard",
  WE_PILOT = "We-pilot",
}

export const JOB_TYPE = {
  PILOT: "PILOT",
  LANCE_BOARD: "LANCE_BOARD",
};

export type PlatformType = (typeof PlatformEnum)[keyof typeof PlatformEnum];

export type PostJobFormType = {
  title: string;
  description: string;
  files: File[];
  skills: { id: string; name: string }[];
  priority?: string;
  detailOfWork?: string;
  visibility?: QuestVisibilityType;
  budget: number;
  dueDate: string;
  project: {
    rtbId?: string;
    id: string;
    name: string;
  };
  aiPrompt?: string;
  platform?: PlatformType[];
  regional: string;
};
